import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserTenantDto } from 'projects/shared/src/lib/models/TenantDto';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';

@Component({
  selector: 'confirm-tenant-user',
  templateUrl: './confirm-tenant-user.component.html',
  styleUrls: ['./confirm-tenant-user.component.scss']
})
export class ConfirmTenantUserComponent implements OnInit {
  @Input('userTenant') userTenant!: UserTenantDto; 
  @Input('baseUser') baseUser!: UserDto; 
  @Input('stayExpanded') stayExpanded!: boolean; 
  

  @Output() onChangeTenantUser: EventEmitter<UserDto> = new EventEmitter();

  userTenantForm!: FormGroup;
  //userMainForm!: FormGroup;
  
  user!: UserDto;
  isRelevantUser: boolean = false;
  tenantVisible = true;

  constructor(
    public translate: TranslateService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private accountService: AccountService,
    private tenantService: TenantService
  )
   {

   }

  ngOnInit() {

    // if(this.stayExpanded)
    //   this.tenantVisible = true;
    // else
    this.tenantVisible = !this.userTenant.isConfirmed;

    if(this.userTenant.tenantName != "Basis"){

      console.log("--------> confirm-tenant-user: userTenant = ", this.userTenant);
      this.tenantService.getUser(this.userTenant.tenantName, this.userTenant.userId).subscribe({

        next:(userDto:UserDto) => { 
          this.user = userDto;
          if (this.user) {
            this.createUserTenantForm();
            this.isRelevantUser = true;
          }
        },
        error: (error: any) => {
          this.notificationService.error(`${this.translate.data["ERROR"]}`, "User not found in tenant");  
        }
      });

    }
  }

  createUserTenantForm(){
    //console.log("----------> confirm-tenant-user createForm: user = ", this.user)
    this.userTenantForm = this.formBuilder.group({
      email:[{value: this.user.email, disabled: true}],
      phoneNumber:[this.user.phoneNumber],
    });
  }

  // createUserMainForm(user: UserDto){
  //   this.userMainForm = this.formBuilder.group({
  //     email:[{value: user.email, disabled: true}],
  //     // firstName:[this.user.firstName, Validators.required],
  //     // lastName:[this.user.lastName, Validators.required],
  //     // userName:[(this.user.userName != this.user.email)?this.user.userName:null, Validators.required],
  //     phoneNumber:[user.phoneNumber],
  //   });
  // }


  confirm(){
    if (this.userTenantForm.valid) {
      var screenData = this.userTenantForm.getRawValue();
      this.user.userName = this.baseUser.userName;
      this.user.emailConfirmed = true;
      this.user.first_Name = this.baseUser.first_Name;
      this.user.last_Name = this.baseUser.last_Name;
      // if(this.user.phoneNumber != screenData.phoneNumber){
      //   // s.th. changed ==> stay expanded
      //   this.tenantVisible = true;
      //   console.log("------> s.th. changed")
      // }
      this.user.phoneNumber = screenData.phoneNumber;
      console.log("------> confirm-tenant-user user = ", this.user)

      this.tenantService.updateUserConfirmed(this.userTenant.tenantName, this.user).subscribe({
        next:(userDto:UserDto) => { 
          this.user = userDto;
          // this.onChangeTenantUser.emit(this.user);
          this.userTenant.isConfirmed = true;
          this.tenantService.updateUserTenancy(this.userTenant).subscribe({
            next:(userTenantDto:UserTenantDto) => { 
              //this.userTenant = userTenantDto;
              this.onChangeTenantUser.emit(this.user);
            },
            error: (error: any) => {
            }
          });
    

        },
        error: (error: any) => {
        }
      });

      // this.userTenant.isConfirmed = true;
      // this.tenantService.updateUserTenancy(this.userTenant).subscribe({
      //   next:(userTenantDto:UserTenantDto) => { 
      //     this.userTenant = userTenantDto;
      //     this.onChangeTenantUser.emit(this.user);
      //   },
      //   error: (error: any) => {
      //   }
      // });

    }

  }
}
